const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/UncaughtErrorDialog/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        unknownError: 'Unbekannter Fehler',
        titleWithLocation: 'Es ist ein Fehler in {location} aufgetreten.',
        titleWithoutLocation: 'Ein Fehler ist aufgetreten.',
        closeButton: 'OK',
        kisapiResultHasMoreRows: 'Es wurden nicht alle Resultate geladen, weil die Abfrage zuviele Treffer lieferte.',
    },
    __RELATIVE_SOURCE_FILE__
);
